import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import GiftDetailsLayout from "../components/GiftDetailsLayout";
import { getJourneyBySlug } from "../constants/giftJourney";
import { buildPredefinedDemoGift, getVariantName } from "../constants/predefinedEcardDemos";
import { isKnownOccasionSlug } from "../constants/browseEcardDummies";

export default function PredefinedEcardPage() {
  const { occasionSlug: rawSlug } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const variant = Number(searchParams.get("variant")) || 0;
  const safeVariant = ((variant % 4) + 4) % 4;

  if (!rawSlug || !isKnownOccasionSlug(rawSlug)) {
    return (
      <h2 className="loading" style={{ color: "#b91c1c", padding: "2rem" }}>
        Unknown occasion.
        <Link to="/" style={{ display: "block", marginTop: "1rem" }}>
          ← Home
        </Link>
      </h2>
    );
  }

  const journey = getJourneyBySlug(rawSlug);

  const gift = buildPredefinedDemoGift(journey.slug, safeVariant);
  const moveVariant = (step) => {
    const next = (safeVariant + step + 4) % 4;
    navigate(`/ecard/${encodeURIComponent(journey.slug)}?variant=${next}`, { replace: true });
  };

  return (
    <div>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          padding: "0.65rem 1.25rem",
          background: "rgba(15,23,42,0.82)",
          backdropFilter: "blur(8px)",
          display: "flex",
          gap: "1rem",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link to={`/browse/${journey.slug}`} style={{ color: "#e2e8f0", textDecoration: "none", fontWeight: 600, fontSize: "0.9rem" }}>
          ← Back to designs
        </Link>
        <span style={{ color: "#94a3b8", fontSize: "0.82rem" }}>
          {journey.label} · {getVariantName(journey.slug, safeVariant)}
        </span>
        <div style={{ display: "flex", gap: "0.4rem", alignItems: "center" }}>
          <button
            type="button"
            onClick={() => moveVariant(-1)}
            style={{
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(15,23,42,0.7)",
              color: "#e2e8f0",
              borderRadius: "999px",
              width: "2rem",
              height: "2rem",
              cursor: "pointer",
            }}
            aria-label="Previous preview"
          >
            ←
          </button>
          <button
            type="button"
            onClick={() => moveVariant(1)}
            style={{
              border: "1px solid rgba(255,255,255,0.2)",
              background: "rgba(15,23,42,0.7)",
              color: "#e2e8f0",
              borderRadius: "999px",
              width: "2rem",
              height: "2rem",
              cursor: "pointer",
            }}
            aria-label="Next preview"
          >
            →
          </button>
          <Link to="/" style={{ color: "#e2e8f0", textDecoration: "none", fontSize: "0.9rem" }}>
            Home
          </Link>
        </div>
      </div>
      <GiftDetailsLayout gift={gift} categoryId={journey.slug} variant={safeVariant} />
    </div>
  );
}
